import { useState, useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import Chip from "@mui/material/Chip";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Tooltip from "@mui/material/Tooltip";
import ReportBug from "./ReportBug";
import NewRequestFeature from "./NewRequestFeature";
import { ToastContainer } from "react-toastify";

function Supports(props) {
  const [showTab, setShowTab] = useState("ReportBug");

  const handleEditUserInfo = (e) => {
    setShowTab(e.currentTarget.value);
  };

  const detectSize600px = useMediaQuery("(min-width:600px)");

  const userInfoContent = (selected) => {
    switch (selected) {
      case "ReportBug":
        return <ReportBug />;
      case "NewRequestFeature":
        return <NewRequestFeature />;
      default:
        return "Error";
    }
  };
  return (
    <Grid container sx={{ textAlign: "justify", height: "100vh" }}>
      <Box sx={{ width: "100%", px: 1 }}>
        <Tooltip title="اطلاعات کاربری" arrow>
          <Button value="ReportBug" onClick={handleEditUserInfo} sx={{ mt: 1 }}>
            <Chip
              clickable
              color={showTab == "ReportBug" ? "error" : "warning"}
              icon={<AccountCircleIcon />}
              label={detectSize600px ? "گزارش مشکل در برنامه" : ""}
            />
          </Button>
        </Tooltip>
        <Tooltip title="پیشنهادات یا درخواست ویژگی جدید" arrow>
          <Button
            value="NewRequestFeature"
            onClick={handleEditUserInfo}
            sx={{ mt: 1 }}
          >
            <Chip
              clickable
              color={showTab == "NewRequestFeature" ? "error" : "warning"}
              icon={<ManageAccountsIcon />}
              label={detectSize600px ? "پیشنهادات یا درخواست ویژگی جدید" : ""}
            />
          </Button>
        </Tooltip>
        <hr />
        {userInfoContent(showTab)}
      </Box>
    </Grid>
  );
}

export default Supports;
